export default {
  editor_button_text_placeholderRequestNumber:
    'Solicitar n\u00famero tel\u00e9fono',
  contactCard_default_status:
    'A\u00fan no est\u00e1 en flock, pero puedes enviarle un mensaje',
};
